module.exports = "/_next/static/images/blank-profile-picture-512@2x-375aeb500ddb2e447515f3f6fd414f6a.png";